export default {
  siteName: 'YOYBUY CAM',
  siteTagline: 'Ваш проводник в мир покупок из Китая',
  selectCategory: 'Выберите категорию',
  viewAll: 'Смотреть все',
  goToMain: 'Перейти на сайт',
  backToHome: 'Вернуться на главную',
  readMore: 'Читать далее',
  subscribe: 'Подписаться',
  emailPlaceholder: 'Введите ваш email',
  newsletterTitle: 'Подпишитесь на обновления',
  newsletterDesc: 'Получайте новые статьи и лучшие предложения на почту',
  privacy: 'Политика конфиденциальности',
  terms: 'Условия использования',
  copyright: '© 2026 YOYBUY CAM. Все права защищены.',
  footerLinks: {
    categories: 'Категории',
    articles: 'Статьи',
    about: 'О сервисе',
  },
  nav: {
    home: 'Главная',
    categories: 'Категории',
    guide: 'Руководство',
    blog: 'Блог',
  },
};